import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const blogAnalyticsSectionStyles: Record<string, SxProps<Theme>> = {
  section: {
    scrollMarginTop: 24,
  },
  card: {
    p: 2.5,
    borderRadius: 3,
    border: (t) => `1px solid ${alpha(t.palette.divider, 0.1)}`,
    bgcolor: "background.paper",
    boxShadow: (t) =>
      t.palette.mode === "dark"
        ? `0 4px 20px ${alpha("#000", 0.3)}`
        : `0 2px 12px ${alpha("#000", 0.06)}`,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: (t) =>
        t.palette.mode === "dark"
          ? `0 8px 28px ${alpha("#000", 0.4)}`
          : `0 4px 20px ${alpha("#000", 0.08)}`,
    },
  },
  statValue: {
    fontWeight: 700,
    fontSize: "1.75rem",
    background: "linear-gradient(135deg, #f8481c 0%, #ff6b4a 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  chartContainer: {
    height: 280,
    borderRadius: 2,
    bgcolor: (t) => alpha(t.palette.background.default, 0.5),
    p: 2,
  },
  emptyState: {
    py: 8,
    textAlign: "center",
    color: "text.secondary",
  },
};

export default blogAnalyticsSectionStyles;
